import Namee81 from '../../../Media/BSD/Eonna/Eonna Namee 8.webp'
import Namee82 from '../../../Media/BSD/Eonna/Eonna Namee 8.webp'





const Namee8images =[
Namee81,Namee82
]

export default Namee8images;